import defaultImg from '../../../../assets/image/newShop/defaultImg.png';
import {shortenString} from '../../../../utilities/helper/shortenString';
import RateStarBadge from '../../../RateStarBadge';
interface IShopDetailCard {
  city?: ICity;
  state?: IState;
  logo?: string;
  title?: string;
  rate?: number;
}

const ShopDetailCard = ({city, state, logo, title, rate}: IShopDetailCard) => {
  return (
    <div className="flex justify-between h-[72px] items-center border rounded-lg py-2 px-3  shadow-xs">
      <div className="flex items-center">
        <img
          alt={`logo-${title}`}
          src={logo || defaultImg}
          className="object-contain overflow-hidden w-14 h-14 rounded-full"
        />
        <div className="flex flex-col gap-1 justify-between py-2 mr-3">
          <div className="flex items-center">
            <span className="text-sm font-medium">
              {shortenString(title!, 5)}
            </span>
            {rate !== undefined && rate !== 0 && (
              <RateStarBadge rate={rate} propsClass="mr-2" />
            )}
          </div>
          <div className="flex items-center text-gray-700 text-md">
            <i className="icon-nameLocation1" />
            <span className="text-xs mr-0.5">
              {state?.name}, {city?.name}
            </span>
          </div>
        </div>
      </div>
      <i className="text-gray-700 icon-nameArrow---Left-2 font-DemiBold" />
    </div>
  );
};

export default ShopDetailCard;
